<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {}
}
</script>

<style>
body {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #71b1af;
}
</style>
